import { render, staticRenderFns } from "./TableColumnConfigMenu.vue?vue&type=template&id=28727b7a&scoped=true"
import script from "./TableColumnConfigMenu.vue?vue&type=script&lang=js"
export * from "./TableColumnConfigMenu.vue?vue&type=script&lang=js"
import style0 from "./TableColumnConfigMenu.vue?vue&type=style&index=0&id=28727b7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28727b7a",
  null
  
)

export default component.exports